module.exports = __webpack_public_path__ + "img/goals-empty.962c5449.svg";